import { all } from 'redux-saga/effects'

import { candidatesSaga } from './candidates/sagas'

export function* jobSaga() {
  yield all([candidatesSaga()])
}
